import type { ButtonHTMLAttributes } from 'react';

// Import styles
import { StyledButton, StyledIconInfo } from './styles';

export const MoreInfoButton = (props: ButtonHTMLAttributes<HTMLButtonElement>) => (
	<StyledButton {...props}>
		<StyledIconInfo />
	</StyledButton>
);
